import { action, Action } from 'easy-peasy';
import { svgConfig } from '@/router/design-svg/constants';
import { ISvgInfo, Shape } from '@/router/design-svg/types';

export interface ISvgModel {
    svgConfig: ISvgInfo;
    curShape: Shape;
    setSvgConfig: Action<ISvgModel, ISvgInfo>;
    setCurShape: Action<ISvgModel, Shape>;
}

export const svgModel: ISvgModel = {
    svgConfig,
    setSvgConfig: action((state, preload) => {
        state.svgConfig = preload;
    }),
    curShape: Object.keys(svgConfig)[0] as Shape,
    setCurShape: action((state, preload) => {
        state.curShape = preload;
    }),
};
